import React, { useState } from "react";
import { jsPDF } from "jspdf";
import Navbar from "../components/Navbar";
import "./Support.css";

const BASE_URL = window.location.hostname === "localhost" ? "http://localhost:5000" : "https://success-blog-app-backend.onrender.com";
const PRESETS = [25, 50, 100];

function loadRazorpay() {
  return new Promise((resolve) => {
    if (window.Razorpay) { resolve(true); return; }
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}

export default function Support() {
  const [amount, setAmount] = useState(50);
  const [customAmount, setCustomAmount] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [receipt, setReceipt] = useState(null);

  const selectedAmount = customAmount.trim() ? Number(customAmount) : amount;
  const validAmount = Number.isInteger(selectedAmount) && selectedAmount >= 10 && selectedAmount <= 100000;
  const chooseAmount = (value) => { setAmount(value); setCustomAmount(""); setError(""); };

  const downloadReceipt = () => {
    if (!receipt) return;
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    doc.setFillColor(61, 34, 20); doc.rect(0, 0, pageWidth, 44, "F");
    doc.setTextColor(255, 248, 239); doc.setFont("helvetica", "bold"); doc.setFontSize(22);
    doc.text("THEBLOGSSPHERE", 20, 22);
    doc.setFont("helvetica", "normal"); doc.setFontSize(11);
    doc.text("Good Content. Better Tomorrow.", 20, 31);
    doc.setTextColor(61, 34, 20); doc.setFont("helvetica", "bold"); doc.setFontSize(22);
    doc.text("Thank You!", pageWidth/2, 66, { align: "center" });
    doc.setFont("helvetica", "normal"); doc.setFontSize(12);
    doc.text("Your kindness means a lot to us.", pageWidth/2, 75, { align: "center" });
    doc.setDrawColor(225,198,174); doc.roundedRect(18, 90, pageWidth-36, 90, 4, 4);
    doc.setFont("helvetica", "bold"); doc.setFontSize(12); doc.text("PAYMENT RECEIPT", 26, 103);
    doc.setFontSize(22); doc.text(`INR ${Number(receipt.amount).toFixed(2)}`, 26, 118);
    doc.setFont("helvetica", "normal"); doc.setFontSize(10);
    const rows = [["Email", receipt.email], ["Payment ID", receipt.paymentId], ["Date", new Date(receipt.paidAt).toLocaleString()], ["Status", "Payment Verified"]];
    let y = 132;
    rows.forEach(([l,v]) => { doc.setFont("helvetica","bold"); doc.text(`${l}:`,26,y); doc.setFont("helvetica","normal"); doc.text(String(v),65,y); y+=10; });
    doc.setFontSize(11); doc.text("Thank you for supporting THEBLOGSSPHERE!", pageWidth/2, 195, {align:"center"});
    doc.save("THEBLOGSSPHERE-Thank-You-Slip.pdf");
  };

  const payNow = async (e) => {
    e.preventDefault(); setError("");
    if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { setError("Please enter a valid email address."); return; }
    if (!validAmount) { setError("Amount must be between ₹10 and ₹1,00,000."); return; }
    setLoading(true);
    try {
      const loaded = await loadRazorpay();
      if (!loaded) throw new Error("Checkout failed to load.");
      const orderRes = await fetch(`${BASE_URL}/api/support/order`, { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({amount:selectedAmount, email:email.trim()}) });
      const order = await orderRes.json();
      if (!orderRes.ok) throw new Error(order.message || "Order failed");
      const checkout = new window.Razorpay({
        key: order.keyId, amount: order.amount, currency:"INR", name:"THEBLOGSSPHERE", description:"Buy Me a Treat", order_id: order.orderId, prefill:{email:email.trim()}, theme:{color:"#3d2214"},
        handler: async (res) => {
          try {
            const verifyRes = await fetch(`${BASE_URL}/api/support/verify`, { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({ orderId:res.razorpay_order_id, paymentId:res.razorpay_payment_id, signature:res.razorpay_signature, email:email.trim() }) });
            const result = await verifyRes.json();
            if (!verifyRes.ok || !result.success) throw new Error(result.message || "Verification failed");
            setReceipt({ amount:selectedAmount, email:email.trim(), paymentId:res.razorpay_payment_id, paidAt: result.paidAt || new Date().toISOString() });
            window.scrollTo({top:0, behavior:"smooth"});
          } catch(err){ setError(err.message); } finally{ setLoading(false); }
        },
        modal:{ ondismiss:()=>setLoading(false) }
      });
      checkout.on("payment.failed", (r)=>{ setError(r.error?.description || "Payment failed"); setLoading(false); });
      checkout.open();
    } catch(err){ setError(err.message); setLoading(false); }
  };

  return (
    <>
      <Navbar />
      <main className="treat-page">
        {receipt ? (
          <section className="success-page">
            <div className="success-icon">✓</div>
            <p className="eyebrow">A LITTLE KINDNESS GOES A LONG WAY</p>
            <h1>Thank You! <span>♥</span></h1>
            <p className="success-intro">Your <b>kindness</b> means a lot to us! Thank you for <b>supporting THEBLOGSSPHERE</b>.</p>
            <div className="receipt-card">
              <div className="receipt-brand">
                <span className="brand-mark">◈</span>
                <div><strong>THEBLOGSSPHERE</strong><small>Good Content · Better Tomorrow</small></div>
              </div>
              <div className="receipt-amount"><span>YOUR TREAT</span><strong>₹{Number(receipt.amount).toFixed(2)}</strong><span className="verified">✓ Payment Verified</span></div>
              <div className="receipt-row"><span>Email</span><strong>{receipt.email}</strong></div>
              <div className="receipt-row"><span>Payment ID</span><strong>{receipt.paymentId}</strong></div>
              <div className="receipt-row"><span>Date</span><strong>{new Date(receipt.paidAt).toLocaleString()}</strong></div>
              <p className="receipt-message">Keep creating. Keep inspiring. ♥</p>
              <button className="pay-button" type="button" onClick={downloadReceipt}>↓ Download Thank-You Slip</button>
              <a className="back-button" href="/support">← Back to Support</a>
            </div>
          </section>
        ) : (
          <>
            <section className="treat-hero">
              {/* LEFT CONTENT */}
              <div className="hero-copy">
                <p className="eyebrow">SUPPORT THE BLOG ♥</p>
                <h1>Buy Me a<br /><span>Treat</span> <i>♡</i></h1>
                <p>A <b>small treat</b> from you means a <b>lot to us</b>! Your support helps us create <b>better content</b>, grow our community and keep <b>THEBLOGSSPHERE alive</b>.</p>
                <p className="handwritten">Good coffee.<br />Better stories.<br />Together! ♡</p>
              </div>

              {/* RIGHT - ATTRACTIVE CARD WITH TEA CUP INSIDE */}
              <div className="coffee-art">
                <div className="steam steam-one"></div>
                <div className="steam steam-two"></div>
                <div className="steam steam-three"></div>

                <div className="coffee-cup">
                  <div className="latte">♡</div>
                </div>

                <div className="stylish-brand-name">
                  <strong>THEBLOGSSPHERE</strong>
                  <span>Good Content · Better Tomorrow</span>
                </div>
              </div>
            </section>

            <section className="support-card">
              <form onSubmit={payNow}>
                <h2><span>☕</span> Choose your <b>treat amount</b></h2>
                <div className="amount-options">
                  {PRESETS.map((v)=>(
                    <button key={v} type="button" className={!customAmount && amount===v ? "amount-option active" : "amount-option"} onClick={()=>chooseAmount(v)}>₹{v}{!customAmount && amount===v && <span> ✓</span>}</button>
                  ))}
                </div>
                <label className="custom-amount"><span>₹</span><input type="number" min="10" max="100000" step="1" value={customAmount} onChange={(e)=>setCustomAmount(e.target.value)} placeholder="Enter custom amount (min ₹10)" /></label>
                <small className="field-hint">Minimum <b>₹10</b> · Maximum <b>₹1,00,000</b></small>
                <label className="email-label" htmlFor="treat-email"><span>✉</span> Your <b>email address</b></label>
                <input id="treat-email" className="email-input" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="Enter your email address" required />
                <small className="field-hint">Your <b>thank-you slip</b> will be available after payment.</small>
                {error && <p className="support-error">{error}</p>}
                <button className="pay-button" type="submit" disabled={loading}>{loading ? "Processing..." : `♡ Pay Now — ₹${validAmount ? selectedAmount : amount} →`}</button>
                <div className="secure-note"><span>🔒</span> Secure Payment <i /> Powered by <b>Razorpay</b></div>
              </form>
            </section>

            <section className="support-benefits">
              <div><span>♡</span><p><b>Your Support</b><br />Matters</p></div>
              <div><span>☕</span><p><b>Helps Us</b><br />Create More</p></div>
              <div><span>♧</span><p><b>Builds Stronger</b><br />Community</p></div>
            </section>
          </>
        )}
        <footer className="treat-footer">Made with <b>♥</b> for <b>THEBLOGSSPHERE</b></footer>
      </main>
    </>
  );
}